import { type TDispatchStructuredLogMessageEvent } from '../types/adscopilot-structured-log-types';
import { createStructuredLogMessage } from './create-structured-log-message';
import { dispatchStructuredLogEvent } from './dispatch-structured-log-event';

export const dispatchStructuredLogMessageEvent: TDispatchStructuredLogMessageEvent = (params) => {
  const { activity } = params;

  if (
    ['Welcome', 'AnimationCard'].includes(activity.value)
    || activity.type !== 'message'
    || (activity.value?.StreamingStatus != null && activity.value.StreamingStatus !== 'Completed')
    || ((activity as any)?.isFromRestore === true && activity.value as unknown !== 'LiveAgentMessage')
  ) return;

  const structuredLogMessage = createStructuredLogMessage(params);

  dispatchStructuredLogEvent(structuredLogMessage);
};
